"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.getLocale=exports.setLocale=void 0;/*
 * This file is part of the ReactI18nRouting package.
 *
 * Copyright (c) 2018-present Friends Of ECMAScript
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */var currentLocale=null,setLocale=a=>{currentLocale=a};exports.setLocale=setLocale;var getLocale=()=>currentLocale;exports.getLocale=getLocale;